<footer>
    <div class="container">
        <div class="d-flex">
            <div class="logo flex-fill" >
                <a href="https://vassardigital.ai/"><img src="./assets/imgs/logo-vassar-digital-ai.svg" width="127" alt="MobileWISE"></a>
                
            </div>
        </div>
    </div>
    <div class="copyright">
        <div class="container">
            <div class="content">
                <p>Copyright&copy;{{date}} Vassar Digital AI. All Rights Reserved.</p>
                <div class="social-links">
                    <a  ngbTooltip="LinkedIn"><i class="mdi mdi-linkedin"></i></a>
                    <a  ngbTooltip="Google"><i class="mdi mdi-google"></i></a>
                    <a  ngbTooltip="X (Twitter)"><i class="mdi mdi-twitter"></i></a>
                    <a  ngbTooltip="Facebook"><i class="mdi mdi-facebook"></i></a>
                </div>
            </div>
        </div>
    </div>
</footer>